import React from "react";

import WrapArrow from "../primitives/WrapArrow";

const HostedByNetlife = () => {
  return (
    <a
      className="
        block
        group
        w-full
        pt-2 pb-14
        bg-black text-white
        text-sm md:text-md xl:text-lg 
        uppercase font-bold text-center
        antialiased
        hover:text-green
        z-0
      "
      href="https://www.netlife.com/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="hidden xxl:inline">
        <WrapArrow direction="right" />
        <WrapArrow direction="right" />
        <WrapArrow direction="right" />
      </span>
      <span>A conference created & hosted by Netlife</span>
      <span className="hidden xxl:inline">
        <WrapArrow direction="left" />
        <WrapArrow direction="left" />
        <WrapArrow direction="left" />
      </span>
    </a>
  );
};

export default HostedByNetlife;
